import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Season } from '../../models';

@Component({
  selector: 'app-wis-pricing',
  templateUrl: './wis-pricing.component.html',
  styleUrls: ['./wis-pricing.component.css']
})
export class WisPricingComponent implements OnInit {
  comicpricingForm: FormGroup;
  showprice: any = false;
  id: any;
  price: any;
  loading: boolean = false;
  load: boolean = false;
  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private route: ActivatedRoute) { }

  ngOnInit() {
    this.comicpricingForm = this.form.group({
      seasonprice: ['', [Validators.required]],
      seasonvalidity: ['', [Validators.required]],
      episodeprice: ['', [Validators.required]],
      episodevalidity: ['', [Validators.required]],
      status: ['', [Validators.required]],
      IsAllowPointsPurchase:["false",[Validators.required]],
    });
    if (this.route.params) {
      this.route.params.subscribe(params => {
        this.id = params['id'];
        if (this.id) {
          const seasondoc: AngularFirestoreDocument<Season> = this.afs.doc('WISSeason/' + this.id)
          seasondoc.valueChanges().subscribe(singleepisode => {
            this.price = singleepisode.pricing_type;
            if (this.price != 'Free') {
              const pricedetails = singleepisode.prices;
              this.comicpricingForm.get('seasonprice').setValue(pricedetails['seasonprice']);
              this.comicpricingForm.get('seasonvalidity').setValue(pricedetails['seasonvalidity']);
              this.comicpricingForm.get('episodeprice').setValue(pricedetails['episodeprice']);
              this.comicpricingForm.get('episodevalidity').setValue(pricedetails['episodevalidity']);
              this.comicpricingForm.get('IsAllowPointsPurchase').setValue(String(singleepisode['IsAllowPointsPurchase']));
            }
            this.showprice = true;
          });
        }
      });
    }

  }

  addpricing(value, valid) {
    try {
      if (value.status != 'Free') {
        if (valid) {
          this.loading=true;
          value.IsAllowPointsPurchase = JSON.parse(value.IsAllowPointsPurchase);

          this.afs.doc('WISSeason/' + this.id).update({ pricing_type: value.status, prices: value,IsAllowPointsPurchase:value.IsAllowPointsPurchase});
          this.router.navigate(['/wis-season']);
        } else {
          this.loading=false;
          this.load=true;
          console.log('error');
        }
      } else {
        this.afs.doc('WISSeason/' + this.id).update({ pricing_type: 'Free' });
        this.router.navigate(['/wis-season']);
      }
    } catch (error) {
      console.log(error);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/wis/wis-pricing/wis-pricing.component.ts